import React, {Fragment, useRef, useState} from "react";
import TableRow from "@mui/material/TableRow";
import TableCell from "@mui/material/TableCell";
import Paper from "@mui/material/Paper";
import TableBody from "@mui/material/TableBody";
import Table from "@mui/material/Table";
import TextField from "@mui/material/TextField";
import TableContainer from "@mui/material/TableContainer";
import Grid from "@mui/material/Grid";
import {styled} from "@mui/material/styles";
import {v4} from "uuid";
import CreateIcon from '@mui/icons-material/Create';
import DialogContent from "@mui/material/DialogContent";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import ClearIcon from '@mui/icons-material/Clear';
import Button from "@mui/material/Button";
import AddIcon from '@mui/icons-material/Add';
import RemoveIcon from '@mui/icons-material/Remove';
import {s_char, s_char_lp_changes} from "../../_signals/s_char";
import updChar from "../../_sig_api/updChar";
import {ICharLPChanges} from "../../_interfaces/ICharLPChanges";
import {LPChangesCreate} from "../../_api/BELPChanges";
import {useSignals} from "@preact/signals-react/runtime";

const Item = styled(Paper)(({theme}) => ({
    backgroundColor: '#fff', ...theme.typography.body2,
    padding: 2,
    textAlign: 'center',
    color: '#000',
}));


function LP() {
    useSignals()

    const lpRef= useRef<HTMLInputElement|null>(null);
    const noteRef= useRef<HTMLInputElement|null>(null);

    const [open, setOpen] = useState(false)


    const changesRow = (row: ICharLPChanges) => {
        return <TableRow key={v4()}><TableCell>{row.entry}</TableCell></TableRow>
    }

    const add = () => {
        setOpen(true);
    }

    const close = () => {
        setOpen(false);
    }

    const addLP = () => {
        const value = lpRef.current?.value as string;
        const note = noteRef.current?.value as string;

        let lp_current = s_char.value.lp_current;
        lp_current = lp_current + parseInt(value);


        let lp_sum = s_char.value.lp_sum;
        lp_sum = lp_sum + parseInt(value);

        updChar([{k: 'lp_current', v: lp_current}, {k: 'lp_sum', v: lp_sum}])

        let lp_changes = s_char_lp_changes.value;
        const time = new Date().toISOString();
        const add:ICharLPChanges = {id: v4(), cid: s_char.value.id, ts: time, entry: '+' + value + ' ' + note}
        lp_changes.unshift(add);
        s_char_lp_changes.value = lp_changes
        LPChangesCreate(add)

        setOpen(false);

        if (lpRef.current) {
            lpRef.current.value = '0';
        }

        if (noteRef.current) {
            noteRef.current.value = "";
        }
    }

    const removeLP = () => {
        let lp_current = s_char.value.lp_current;
        let lp_changes = s_char_lp_changes.value;

        const value = lpRef.current?.value as string;
        const note = noteRef.current?.value as string;

        if (lp_current - parseInt(value) > 0) {
            lp_current = lp_current - parseInt(value);

            updChar([{k: 'lp_current', v: lp_current}])

            const time = new Date().toISOString();
            const add :ICharLPChanges= {id: v4(), cid: s_char.value.id, ts: time, entry: '-' + value + ' ' + note}
            lp_changes.unshift(add);
            s_char_lp_changes.value = lp_changes
            LPChangesCreate(add)
        }

        setOpen(false);

        if (lpRef.current) {
            lpRef.current.value = '0';
        }
        if (noteRef.current) {
            noteRef.current.value = "";
        }
    }

    return <Paper style={{overflowX: 'auto', marginTop: "14px"}}>
        <h3 style={{margin: "5px"}}>Legendenpunkte</h3>

        <Fragment>
            <Grid container spacing={1}>
                <Grid item xs={5}>
                    <Item>
                        <div>LP frei: {s_char.value.lp_current}</div>
                    </Item>
                </Grid>
                <Grid item xs={5}>
                    <Item>
                        <div>LP gesamt: {s_char.value.lp_sum}</div>
                    </Item>
                </Grid>
                <Grid item xs={2} style={{textAlign: 'right'}}>
                    <Button className={'btn'} id="post" onClick={() => add()}>
                        <CreateIcon/>
                    </Button>
                </Grid>
            </Grid>

            <TableContainer key={v4()} style={{maxHeight: 120, marginBottom: 16, marginTop: 16}}>
                <Table key={v4()} stickyHeader style={{width: '100%'}}>
                    <TableBody key={v4()}>{s_char_lp_changes.value.map((row) => changesRow(row))}</TableBody>
                </Table>
            </TableContainer>

            <Dialog open={open}>
                <DialogContent>
                    <Item style={{width: '100%'}}>
                        <TextField InputLabelProps={{shrink: true}}
                                   style={{marginLeft: 8, maxWidth: 80}}
                                   defaultValue={0}
                                   inputRef={lpRef}
                                   variant="standard"
                                   type="number"
                                   label="Legendenpunkte"
                                   name="lp"/>
                    </Item>
                    <Item style={{width: '100%'}}>
                        <TextField InputLabelProps={{shrink: true}}
                                   style={{marginLeft: 8, width: '100%'}}
                                   defaultValue={""}
                                   inputRef={noteRef}
                                   variant="standard"
                                   label="Bemerkung"/>
                    </Item>
                </DialogContent>
                <DialogActions>
                    <AddIcon onClick={() => addLP()}></AddIcon>
                    <RemoveIcon onClick={() => removeLP()}></RemoveIcon>
                    <Button className={'btn'} id="post" onClick={() => close()}><ClearIcon/></Button>
                </DialogActions>
            </Dialog>

        </Fragment>
    </Paper>


}

export default LP;
